import { selectKrcCurriculumDisciplineNode } from '@newStore/documentUI/transformContent/krcContentNodeSelectors';
import { getAllOfResource } from '@newStore/externalData/externalDataState';
import { pathMap } from '@newStore/externalData/externalDataTypes';
import { krcCurriculumRoot, referenceFrames } from '@newStore/referenceFrames/referenceFrames';
import { loadReferenceFrame } from '@newStore/referenceFrames/referenceFramesState';
import {
  type BuildingBlockNodeConfig,
  NodeType,
  type RootNodeConfig,
} from '@nodeTypeConfig/configTypes';
import { identifierComponent } from '@nodeTypeConfig/helpers/editComponents/identifierComponent';
import { titleComponent } from '@nodeTypeConfig/helpers/editComponents/titleComponent';
import { settings } from '../../settings';

const KRC_CURRICULUM_DISCIPLINE: RootNodeConfig & BuildingBlockNodeConfig = {
  nodeSelector: selectKrcCurriculumDisciplineNode,
  information: {
    single: 'Discipline',
    plural: 'Disciplines',
    category: 'LEERPLAN',
  },
  onLoadActions: [
    getAllOfResource({ resource: pathMap.minimumGoals, refresh: false }),
    loadReferenceFrame({ referenceFrame: referenceFrames.krc }),
    loadReferenceFrame({ referenceFrame: krcCurriculumRoot }),
  ],
  tocTypes: [NodeType.KRC_CURRICULUM_DOMAIN, NodeType.KRC_CURRICULUM_SUBDOMAIN],
  buildingBlocks: [{ type: NodeType.KRC_CURRICULUM_DOMAIN }],
  edit: [
    {
      ...identifierComponent,
      width: 2,
    },
    {
      ...titleComponent,
      width: 10,
    },
  ],
  documentViewIdentifier: 'i',
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
  isCreatable: false,
  isSearchable: true,
  isImportable: false,
  allowSuggestions: false,
  websiteHref: null,
  ...(settings.apisAndUrls.krcSelector && {
    previewModes: [
      {
        type: 'URL',
        name: 'Opstap Selector',
        location: `${settings.apisAndUrls.krcSelector}/?preview`,
      },
    ],
  }),
};

export default KRC_CURRICULUM_DISCIPLINE;
